import React from 'react';
import { SequencerLiveEditor } from '../live/SequencerLiveEditor';
import type { StudioLiveEditorProps } from '../types/editor.types';

export function SequencerBuilder(props: StudioLiveEditorProps) {
  return <SequencerLiveEditor {...props} />;
}
